import { render } from "./EnbProduto02.vue?vue&type=template&id=2deba6a0&scoped=true"
import script from "./EnbProduto02.vue?vue&type=script&lang=js"
export * from "./EnbProduto02.vue?vue&type=script&lang=js"

import "./EnbProduto02.vue?vue&type=style&index=0&id=2deba6a0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2deba6a0"]])

export default __exports__